class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    super.updateOptions();
    super.updateVariant();
    super.toggleAddButton(false, '');
    super.handleErrorMessage();
    super.filterOptions();

    if (!this.currentVariant) {
      super.toggleAddButton(true, '');
      super.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      super.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    super.updateVariantInput();
    this.renderProductInfo();
    this.checkUnSelectOptions();
  }

  checkUnSelectOptions() {
    let unselectOptions = [];
    let unselectOptionsString = '';
    let selectOptionsString = window.variantStrings.selectOptions;
    let andOptionSeparatorString = window.variantStrings.andOptionSeparator;

    this.options.forEach((option) => {
      if (
        !this.querySelector(`input[data-name="${option.name}"]:checked`) &&
        !this.querySelector(`select[data-name="${option.name}"]`)
      ) {
        unselectOptions.push(option.name);
      }
    });

    if (unselectOptions.length === 0) return;

    unselectOptions.forEach((option, index) => {
      if (unselectOptionsString != '' && index !== unselectOptions.length - 1) {
        unselectOptionsString += ', ';
      } else if (
        unselectOptionsString != '' &&
        index === unselectOptions.length - 1
      ) {
        unselectOptionsString += ` ${andOptionSeparatorString} `;
      }

      unselectOptionsString += option;
    });

    super.toggleAddButton(
      true,
      `${selectOptionsString.replace('[[options]]', unselectOptionsString)}`,
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  renderProductInfo() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`,
    );

    if (!destinationPrice) {
      return;
    }

    destinationPrice.innerHTML = this.currentVariant.price_html;
    destinationPrice.classList.remove('visually-hidden');
  }
}

customElements.define('main-product-selector', MainProductSelector);
